import ErrorPage from './404';

export default ErrorPage;
